import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

export const fetchAssignmentCustomers = (filter = {}) => {
  const qs = new URLSearchParams();
  if (filter.regionId) qs.append("regionId", filter.regionId);
  if (filter.bunitId) qs.append("bunitId", filter.bunitId);
  if (filter.status) qs.append("status", filter.status);
  if (filter.search) qs.append("search", filter.search);
  qs.append("page", filter.page ?? 1);
  qs.append("pageSize", filter.pageSize ?? 50);
  return apiClient(`${ENDPOINTS.PAYMENT_INSTRUCTION.LIST_CUSTOMERS}?${qs}`, {
    method: "GET",
  });
};

export const fetchActiveInstructionByCustomer = (customerId) => {
  return apiClient(ENDPOINTS.PAYMENT_INSTRUCTION.BY_CUSTOMER(customerId), {
    method: "GET",
    suppressToast: true,
  });
};

export const assignPaymentInstruction = ({
  customerIds,
  jkBankAccountId,
  sendEmail = false,
  connectionId = null,
}) => {
  return apiClient(
    ENDPOINTS.PAYMENT_INSTRUCTION.ASSIGN,
    {
      method: "POST",
      body: { customerIds, jkBankAccountId, sendEmail, connectionId },
    },
    { headers: { "Content-Type": "application/json" } }
  );
};

export const sendPaymentInstructionEmailSingle = (instructionId) => {
  return apiClient(
    ENDPOINTS.PAYMENT_INSTRUCTION.SEND_EMAIL_SINGLE(instructionId),
    { method: "POST" }
  );
};

// Returns immediately with { jobId, total }. Progress arrives via SignalR.
export const sendPaymentInstructionEmailBulk = ({
  instructionIds,
  connectionId,
}) => {
  return apiClient(
    ENDPOINTS.PAYMENT_INSTRUCTION.SEND_EMAIL_BULK,
    {
      method: "POST",
      body: { instructionIds, connectionId },
    },
    { headers: { "Content-Type": "application/json" } }
  );
};
